import { useQuery } from '@tanstack/react-query'
import { SALESFORCE_CUSTOMER_SEARCH_LIMIT } from 'shared'
import { getSalesforceCustomers } from '@/lib/apiClients/salesforce'
import { queryKeys } from '@/lib/queryKeys'

/**
 * 顧客名 `q` で salesforce_customers を部分一致検索する。
 *
 * 顧客は数万件規模あるため全件取得はせず、`q` が空のときは fetch しない。
 * 呼び出し側で「検索バー → デバウンスで q を確定 → このフックに渡す」フローを想定。
 */
export function useSalesforceCustomers(q: string) {
  return useQuery({
    queryKey: queryKeys.salesforceCustomers(q),
    queryFn: async () => {
      return getSalesforceCustomers({ q, limit: SALESFORCE_CUSTOMER_SEARCH_LIMIT })
    },
    enabled: q.length > 0,
    staleTime: 1000 * 60 * 30,
  })
}
